import React from 'react';
import {
  ComponentParams,
  ComponentRendering,
  Placeholder,
} from '@sitecore-jss/sitecore-jss-nextjs';
import {
  getClassValue,
  getCombinedStyles,
} from '../../helpers/Providers/bokfDefaultClassNameProvider';

interface ComponentProps {
  rendering: ComponentRendering & { params: ComponentParams };
  params: ComponentParams;
}

export const Default = (props: ComponentProps): JSX.Element => {
  const styles = getCombinedStyles(props.params.GridParameters, props.params.Styles);
  const columnWidths = [
    getClassValue(props.params.ColumnWidth1),
    getClassValue(props.params.ColumnWidth2),
    getClassValue(props.params.ColumnWidth3),
    getClassValue(props.params.ColumnWidth4),
    getClassValue(props.params.ColumnWidth5),
    getClassValue(props.params.ColumnWidth6),
    getClassValue(props.params.ColumnWidth7),
    getClassValue(props.params.ColumnWidth8),
  ];
  const columnStyles = [
    getClassValue(props.params.Styles1),
    getClassValue(props.params.Styles2),
    getClassValue(props.params.Styles3),
    getClassValue(props.params.Styles4),
    getClassValue(props.params.Styles5),
    getClassValue(props.params.Styles6),
    getClassValue(props.params.Styles7),
    getClassValue(props.params.Styles8),
  ];
  const enabledPlaceholders = props.params.EnabledPlaceholders.split(',');
  const id = props.params.RenderingIdentifier;

  return (
    <div className={`bokf-component row column-splitter ${styles}`} id={id ? id : undefined}>
      {enabledPlaceholders.map((ph, index) => {
        const phKey = `column-${ph}-{*}`;
        const phStyles = getCombinedStyles(columnWidths[+ph - 1], columnStyles[+ph - 1]);

        return (
          <div key={index} className={`component-content ${phStyles}`}>
            <div key={`column-${index}`} className="row">
              <Placeholder key={index} name={phKey} rendering={props.rendering} />
            </div>
          </div>
        );
      })}
    </div>
  );
};
